export const SUBSCRIPTION_TIER = {
    ADD_BTN: "subscription-add-btn",
    DELETE_BTN: "subscription-delete-btn",
    DELETE_CONFIRM_BTN: "subscription-delete-confirm-btn",
    DIALOG_TITLE: "subscription-dialog-title",
    LABEL: "subscription-label",
    CHECKBOX: "subscription-checkbox",
    SAVE_BTN: "subscription-save-btn",
    CANCEL_BTN: "subscription-cancel-btn",
    LOADING: "subscription-loading",
    TIER_ROW: "subscription-tier-row",
    ERROR_MESSAGE: "subscription-error-message",
    PAGE_TITLE: "subscription-page-title",
    VALIDATION_ERROR: "subscription-validation-error",
};
